// Wordt nu niet gebruikt voor bunny videos

export default class ResponsiveVideo {
	constructor(video) {
		this.video = video;

		const winWidth = window.innerWidth;

		this.width = winWidth * window.devicePixelRatio; // Get width taking pixel density into account

		this.pickSource();
	}

	pickSource() {
		this.matchedSource = null;
		this.prevDiff = 999999;

		// Loop over all video sources
		this.sourceCount = this.video.children.length;
		this.removedSources = 0;

		const removeSources = new Promise((resolve, reject) => {
			Array.from(this.video.children).forEach((source) => {
				// Get source resolution (by provided by data attribute)
				let sourceWidth = source.dataset.sourcewidth;

				// Compare source resolution to video element width
				let currentDiff = sourceWidth - this.width;
				if (currentDiff <= 0) {
					currentDiff = currentDiff * -1;
				}
				if (currentDiff <= this.prevDiff) {
					this.matchedSource = source;
					this.matchedSourceWidth = sourceWidth;
				}
				this.prevDiff = currentDiff;

				setTimeout(() => {
					source.remove();
					this.removedSources++;
					if (this.removedSources >= this.sourceCount) {
						resolve('Removed All Sources');
					}
				}, 0);
			});
		});

		removeSources.then(() => {
			this.video.src = this.matchedSource.src;
			this.video.load();
		});
	}

	playVideo() {
		this.video.play();
	}

	stopVideo() {
		this.video.pause();
	}

	muteVideo() {
		this.video.muted = false;
	}

	unmuteVideo() {
		this.video.muted = true;
	}
}
